import { Grid, GridItem, Icon, Text } from "@innovationnorway/lighthouse-components";
import React from "react";
import { UserTask } from "../../../../main/models/user-task";
import { handleConvertDate } from "../../../../utils/dateFunctions";
import { sendSiteimproveEvent } from "../../../../utils/sendSiteimproveEvent";
import { useLayout } from "../../../hooks/useLayout";
import "./notificationItem.scss";

interface NotificationItemProps {
  task: UserTask;
  hideProjectInfo?: boolean;
}

const NotificationItem = ({ task, hideProjectInfo }: NotificationItemProps) => {
  const { translations } = useLayout();

  return (
    <a
      className="notification-item"
      href={task.link}
      onClick={() =>
        hideProjectInfo
          ? sendSiteimproveEvent(
              `MyPage-myTasksBeta`,
              "MyTaskItemClicked",
              "Task item clicked: " + task.displayTaskType
            )
          : sendSiteimproveEvent(
              `MyPage-openSummaryBeta`,
              "SummaryItemClicked",
              "Summary item clicked: " + task.displayTaskType
            )
      }
    >
      <Grid style={{ rowGap: "0" }}>
        <GridItem spanLarge={12} spanMedium={12} spanSmall={4}>
          <Text variant="small">{handleConvertDate(task.createdOn)}</Text>
        </GridItem>
        <GridItem
          spanLarge={!hideProjectInfo ? 3 : 7}
          spanMedium={!hideProjectInfo ? 3 : 7}
          spanSmall={!hideProjectInfo ? 1 : 2}
        >
          <Text variant={task.isNew ? "subheading" : "paragraph"} className="notification-item__title">
            {task.isNew && <Icon prefix="fass" iconName="circle" className="notification-item__title__icon" />}
            {task.displayTaskType}
          </Text>
        </GridItem>
        {!hideProjectInfo && (
          <GridItem style={{ justifySelf: "end" }} spanLarge={4} spanMedium={4} spanSmall={1}>
            <Text variant="base" className="data-hj-suppress notification-item__details__projectTitle">
              {task.projectTitle}
            </Text>
          </GridItem>
        )}
        {!hideProjectInfo && (
          <GridItem spanLarge={3} spanMedium={3} spanSmall={1}>
            <Text variant="base" className="data-hj-suppress notification-item__details__accountName">
              {task.accountName}
            </Text>
          </GridItem>
        )}
        <GridItem
          style={{ justifySelf: "end" }}
          spanLarge={!hideProjectInfo ? 2 : 5}
          spanMedium={!hideProjectInfo ? 2 : 5}
          spanSmall={!hideProjectInfo ? 1 : 2}
        >
          <Text variant="paragraph" className="notification-item__link">
            {translations.open}
          </Text>
        </GridItem>
      </Grid>
    </a>
  );
};

export default NotificationItem;
